import React, { useState, useEffect } from "react";
import ct from "class-types.macro";
import { VariantProps } from ".";
import ChatLink from "./ChatLink";
import LowestGuaranteedPriceWithChatNowLink from "./LowestGuaranteedPriceWithChatNowLink";
import LoginLink from "./LoginLink";

const F = ({ user, selectedProduct, productListingView }: VariantProps) => {
  const [currentUrl, setCurrentUrl] = useState("");

  const qualifiedForMapPrice =
    user.registered &&
    (user.platinum.enabled ||
      user.hasWebPlus ||
      (user.analyticsData.total_orders &&
        Number(user.analyticsData.total_orders) >= 2));

  useEffect(() => {
    setCurrentUrl(window.location.pathname);
  }, []);

  const handleChatLinkClick = (event: React.SyntheticEvent) => {
    event.preventDefault();

    window.open(
      `/chat/?referringURL=${encodeURIComponent(currentUrl)}`,
      "",
      "width=650,height=700,resizable=1,scrollbars=1",
    );
  };

  return (
    <div className="map map-override mapF">
      {!user.registered ? (
        <p
          className={ct(
            "font-semibold",
            "text-xs",
            "leading-none",
            "mb-2",
            "text-gray-800",
            productListingView === "list"
              ? ct("m-0", "mt-1", "p-0", "pb-1", "xs:text-center")
              : ct("mb-0", "p-0", "pt-1", "text-center"),
          )}
        >
          {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
            <>
              {"Contact us or "}
              <LoginLink>login</LoginLink>
              {" for details"}
            </>
          ) : (
            "Contact us for details"
          )}
          <ChatLink productListingView={productListingView} />
        </p>
      ) : (
        <div
          className={ct(
            "bg-white",
            "border-red-500",
            "rounded",
            "border-solid",
            "border",
            productListingView === "list"
              ? ct("my-0", "max-w-full", "w-40", "xs:mx-auto", "xs:text-center")
              : ct("text-center"),
          )}
        >
          <LowestGuaranteedPriceWithChatNowLink
            qualifiedForMapPrice={!!qualifiedForMapPrice}
            selectedProduct={selectedProduct}
            currentUrl={currentUrl}
            handleChatLinkClick={handleChatLinkClick}
          />
        </div>
      )}
    </div>
  );
};

export default F;
